export interface IJwtPayload {
    /** Issuer (who created and signed this token) */
    iss: string;
    /** SaaS userId Subject (whom the token refers to) */
    sub: string;
    /** SaaS user code (whom the token refers to) */
    code?: string;
    /** firstName (whom the token refers to) */
    firstName?: string;
    /** lastName (whom the token refers to) */
    lastName?: string;
    /** Issued at (seconds since Unix epoch) */
    iat?: number;
    /** Expiration time (seconds since Unix epoch) */
    exp: number;
    /** Authorization party (the party to which this token was issued) */
    azp?: string;
    /** Audience (who or what the token is intended for) */
    aud?: string[];
    /** Client id (client app id that requested the token)) */
    client_id?: string;
    /** User role scope (what the token is intended to have access ) */
    roles?: string[];
    /** User role scope (what the token is intended to have access ) */
    permissions: string[];
    /** Token scope (what the token has access to) */
    scope?: string;
    /** Unique user id from provider db */
    providerUid?: string;
    /** organizations which user belongs to */
    organizations: any[];
    /** user type */
    typology: string;
    /** organization which user is logged in */
    currentOrganization: string;
    /** phone number */
    phone?: string;
}

export interface IDecodedJwt {
    raw: string;
    header: { alg: string };
    payload: IJwtPayload;
}

export interface AuditableTimestamps {
    createdAt: string;
    updatedAt: string;
}
